import { render, staticRenderFns } from "./courseScheduleDisplayVip.vue?vue&type=template&id=0238584e&scoped=true"
import script from "./courseScheduleDisplayVip.vue?vue&type=script&lang=js"
export * from "./courseScheduleDisplayVip.vue?vue&type=script&lang=js"
import style0 from "./courseScheduleDisplayVip.vue?vue&type=style&index=0&id=0238584e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0238584e",
  null
  
)

export default component.exports